import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../hooks/useUser";
import Loader from "./Spinner.component";

function ProtectedSuperAdmin({ children }) {
  const navigate = useNavigate();
  const { isLoading, isSuperAdmin } = useUser();

  useEffect(() => {
    if (!isSuperAdmin && !isLoading) navigate("/login");
  }, [isSuperAdmin, isLoading, navigate]);

  if (isLoading) return <Loader />;
  if (isSuperAdmin) return children;
}

export default ProtectedSuperAdmin;
